import {ForwardRefRenderFunction, forwardRef, useEffect, useState} from 'react';
import {usePrevious} from '../../../../../../common/shared/hooks/usePrevious';
import {useDrawHtmlInfoHandler} from '../hook/useDrawHtmlInfoHandler.hook';
import {HtmlInfo} from '../type/HtmlInfo.interface';
import {TextViewerCoreOption} from '../type/TextViewerCoreOption.type';
import {checkShouldRedraw} from '../util/checkShouldRedraw';

const _PreviewHtmlScrollViewer: ForwardRefRenderFunction<
  HTMLDivElement,
  {
    htmlInfoList: HtmlInfo[];
    option: TextViewerCoreOption;
    productId: number;
    currentChapterId?: number;
  }
> = ({htmlInfoList, option, productId, currentChapterId}, forwardedRef) => {
  const [containerElement, setContainerElement] =
    useState<HTMLDivElement | null>(null);

  // settingStyleElement가 비어있거나 옵션이 변경됐다면,
  // 컨텐츠의 html, style을 DOM에 덮어씁니다.
  const prevOption = usePrevious(option);

  const {redrawHtmlInfoList} = useDrawHtmlInfoHandler({
    productId,
    containerElement,
    htmlInfoList,
    option,
    currentChapterId,
  });

  useEffect(() => {
    if (!containerElement || !option.size.width || !option.size.height) {
      return;
    }

    const shouldRedraw = checkShouldRedraw({
      option,
      prevOption,
      isPreview: true,
    });

    if (shouldRedraw) {
      redrawHtmlInfoList();
    }
  }, [containerElement, option, prevOption, redrawHtmlInfoList]);

  return (
    <div ref={forwardedRef} className="min-h-screen">
      <div ref={setContainerElement} className="min-h-full" />
    </div>
  );
};

export const PreviewHtmlScrollViewer = forwardRef(_PreviewHtmlScrollViewer);
